// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"DK-z","carousel":"EK-z"};